import { useRef, useState } from "react";
import SelectModel from "../serials/registerSerials/selectModel";
import ArtLabelStep from "./ArtLabelStep";

/**
 * "Adicionar item" (spec §5.2): painel de modelo reaproveitado e, em seguida,
 * o passo "Arte da etiqueta". O SelectModel chama setModel e close em sequência;
 * a ref evita que esse close encerre o fluxo depois de um modelo escolhido.
 */
const AddExtendedArtItem = ({ user, order, onAdded, onClose }) => {
    const [model, setModel] = useState(null);
    const pickedRef = useRef(false);

    if (!model) {
        return (
            <SelectModel
                user={user}
                setModel={(picked) => {
                    if (!picked) return;
                    pickedRef.current = true;
                    setModel(picked);
                }}
                close={() => {
                    if (!pickedRef.current) onClose();
                }}
            />
        );
    }

    return <ArtLabelStep user={user} order={order} model={model} onDone={onAdded} onCancel={onClose} />;
};

export default AddExtendedArtItem;
